// import { GET_JOB_DETAILS } from "./constants/URLS"
import axios, {
    AxiosError,
    AxiosRequestConfig,
    AxiosResponse,
    InternalAxiosRequestConfig,
} from "axios"
import { toast } from "react-toastify"
import { refreshToken } from "./app-interface"
import { config } from "./config"

export const mockHttpClient = axios.create({
    // baseURL: "http://localhost:8000",
    baseURL: config.baseUrl,
})

export const httpClient = axios.create({
    baseURL: config.baseUrl,
})

export const httpLegacyClient = axios.create({
    baseURL: config.legacyBaseUrl,
})

const authInterceptor = function (config: AxiosRequestConfig<any>) {
    const authToken = sessionStorage.getItem("__token__") || import.meta.env.VITE_TOKEN

    if (!authToken) return config

    return {
        ...config,
        headers: {
            ...config.headers,
            Authorization: `Token ${authToken}`,
        },
    }
}

const handleTokenExpiry = (apiConfig: InternalAxiosRequestConfig<any>) => {
    try {
        if (!(window as any).refreshingToken) {
            const currentToken = sessionStorage.getItem("__token__") || ""
            ;(window as any).refreshingToken = true
            refreshToken(currentToken)
        }
        const intervalId = setInterval(() => {
            if (!(window as any).refreshingToken) {
                const token = sessionStorage.getItem("__token__")
                const tempConfig = { ...apiConfig }
                tempConfig.headers.Authorization = `Token ${token}`
                httpClient(tempConfig)
                clearInterval(intervalId)
            }
        }, 200)
    } catch (error) {
        console.log(error)
    }
}

const responseErrorHandler = (error: AxiosError) => {
    if (error.config?.baseURL?.indexOf("https://storage.googleapis")) {
        return null
    }
    if (error.response?.status !== 200) {
        toast.error("Something went wrong with server response", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "colored",
        })
    }
    if (error.response?.status === 401) {
        if (typeof window !== "undefined") {
            // const queryParams = new URLSearchParams({
            //     return_to: window.location.href,
            // });
            // window.location.href = `/login?${queryParams.toString()}`;
            handleTokenExpiry(error.config as any)
        }
    } else if (error.response?.status === 403) {
        if (typeof window !== "undefined") {
            window.location.href = "/"
        } else {
            console.log("Forbidden access", error)
        }
    } else {
        return Promise.reject(error)
    }
}

const responseHandler = (response: AxiosResponse) => response

httpClient.interceptors.request.use(authInterceptor as any)
httpClient.interceptors.response.use(responseHandler, responseErrorHandler)

httpLegacyClient.interceptors.request.use(authInterceptor as any)
httpLegacyClient.interceptors.response.use(responseHandler, responseErrorHandler)

mockHttpClient.interceptors.request.use(authInterceptor as any)
mockHttpClient.interceptors.response.use(responseHandler, responseErrorHandler)
